export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="32" fill="#722F37" />
    <path
      d="M21 13h22M21 51h22M24 13c0 9.5 5.8 12 8 14.5-2.2 2.5-8 5-8 23.5h16c0-18.5-5.8-21-8-23.5C34.2 25 40 22.5 40 13"
      fill="none"
      stroke="#FDFBF7"
      strokeWidth="3.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M25.5 44.5a6.5 6.5 0 0 1 13 0z" fill="#E5C7C2" />
    <path d="M32 36.5v-3M26.5 38.5l-2-2M37.5 38.5l2-2" stroke="#E5C7C2" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M24 44.5h16" stroke="#E5C7C2" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ light = false }) => (
  <a href="/" data-testid="nav-logo" className="flex items-center gap-3">
    <LogoMark />
    <span className={`font-serif text-lg leading-none tracking-tight ${light ? "text-linen" : "text-ink"}`}>
      Prima Ora
      <span className="block text-xs font-sans font-medium uppercase tracking-[0.25em] text-terracotta">
        di libertà
      </span>
    </span>
  </a>
);
